import AccountCategory from './AccountCategory';

const creditCardAccounts = [AccountCategory.CREDIT_CARD];
const depositAccounts = [AccountCategory.DEPOSIT];
const loanAccounts = [AccountCategory.LOAN, AccountCategory.UNSECUREDLOAN];
const otherAccounts = [AccountCategory.OTHER];

const AccountCategoryGroups = {
  LOANS_AND_CREDIT: [...creditCardAccounts, ...loanAccounts],
  // NB: As of now, credit cards should be displayed under both loans and credit, and my accounts.
  MY_ACCOUNTS: [...creditCardAccounts, ...depositAccounts, ...otherAccounts],
};

Object.freeze(AccountCategoryGroups);

export default AccountCategoryGroups;
